import _ from "lodash";
export const getRnPQueryVariablesForProjectGroupCategories = projectGroupCategories => {
  const contexts = _.map(projectGroupCategories, projectGroupCategory => {
    const { id, curriculumProgram } = projectGroupCategory;
    const curriculumProgramId = _.get(curriculumProgram, "id");

    return [
      {
        entityId: id,
        entityType: "PROJECT",
      },
      {
        entityId: curriculumProgramId,
        entityType: "CURRICULUM_PROGRAM",
      },
    ];
  });
  return {
    filters: {
      module: "PROJECTS",
      appType: "TEACHER_WEB",
      contexts,
    },
  };
};
